/**
 * Server-side JS-error logging. Mirrors process-runner's `api/Logging/logging`
 * with one mobile delta: every call carries `app-name=mobile app` so
 * comm-service can segregate mobile telemetry from process-runner.
 *
 * The endpoint is `@Profile({"!prod"})` in comm-service — inert in prod.
 */

import axios from '@services/axios'
import { ENV } from '@services/env'

/**
 * Must match the `JSError` enum in comm-service `LogController`. Modelled as a
 * const object (not a TS `enum`) because the repo runs with
 * `erasableSyntaxOnly`.
 */
export const JSError = {
  RangeError: 'RangeError',
  ReferenceError: 'ReferenceError',
  SyntaxError: 'SyntaxError',
  TypeError: 'TypeError',
  URIError: 'URIError',
  EvalError: 'EvalError',
  InternalError: 'InternalError',
  ApiMaxRetryReached: 'ApiMaxRetryReached',
} as const

export type JSError = (typeof JSError)[keyof typeof JSError]

/** Segregates mobile logs from process-runner in comm-service. */
export const APP_NAME = 'mobile-web-app'

export async function loggingErrorApi(error: JSError) {
  const url =
    `${ENV.comm}/log/logJSError` +
    `?error=${encodeURIComponent(error)}` +
    `&app-name=${encodeURIComponent(APP_NAME)}`

  return axios({
    method: 'POST',
    url,
    headers: { 'Content-Type': 'application/json' },
    // The log call must never retry or trigger session-expired UX on its own
    // failure — otherwise a failing log could recurse into the retry/auth loop.
    disableRetry: true,
    skipAuthRedirect: true,
  }).then((response) => response.data)
}
